module.exports = __webpack_public_path__ + "static/media/4.2cf02ea9.jpg";